let mailtoLinks: NodeList | null;

export function initMailto(){
    mailtoLinks = <NodeList>document.querySelectorAll('[data-mailto]');
    Array.prototype.forEach.call(mailtoLinks, (item: HTMLAnchorElement) => {
        addClickListener(item as HTMLAnchorElement);
    });
}

function addClickListener(item: HTMLElement){
    item.addEventListener('click', (e: MouseEvent) => {
        e.preventDefault();
        setMailtoUrl()
    });
}

function setMailtoUrl() {
    let url = '';
    let args = [];

    if (typeof document.title !== 'undefined') {
        args.push('subject=' + encodeURIComponent(document.title));
    }
    if (typeof window.location.href !== 'undefined') {
        args.push('body=' + encodeURIComponent(window.location.href.replace(location.hash,'')))
    }

    if (args.length > 0) {
        url += '?' + args.join('&');
    }
    window.location.href = 'mailto:' + url;
}
